"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var tag = function (defaultTag) {
    var Base = function (_a) {
        var _b = _a.as, as = _b === void 0 ? defaultTag : _b, props = tslib_1.__rest(_a, ["as"]);
        var Tag = as;
        return react_1.default.createElement(Tag, tslib_1.__assign({}, props));
    };
    return Base;
};
exports.default = tag;
